import { createPopper } from "@popperjs/core";
import { useEffect, useRef, useState } from "react";

const Tooltip = ({
  children,
  tooltipText,
  position = "auto",
  offset = [0, 10],
  className = "",
}) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const btnRef = useRef(null);
  const tooltipRef = useRef(null);
  const arrowRef = useRef(null);
  const popperInstance = useRef(null);
  const toggledByClick = useRef(false);

  const [placement, setPlacement] = useState("bottom");

  useEffect(() => {
    if (tooltipShow) {
      popperInstance.current = createPopper(
        btnRef.current,
        tooltipRef.current,
        {
          placement: position,
          modifiers: [
            {
              name: "offset",
              options: {
                offset: offset,
              },
            },
            {
              name: "arrow",
              options: {
                element: arrowRef.current,
              },
            },
            {
              name: "preventOverflow",
              options: {
                padding: 16,
              },
            },
            {
              name: "updateState",
              enabled: true,
              phase: "write",
              fn: ({ state }) => {
                setPlacement(state.placement);
              },
            },
          ],
        },
      );
    }

    return () => {
      if (popperInstance.current) {
        popperInstance.current.destroy();
        popperInstance.current = null;
      }
    };
  }, [tooltipShow]);

  function getArrowStyles(placement) {
    const baseStyles = {
      width: "0px",
      height: "0px",
      borderStyle: "solid",
    };

    switch (placement) {
      case "top":
        return {
          ...baseStyles,
          borderWidth: "10px 10px 0 10px",
          borderColor: "#333 transparent transparent transparent",
          bottom: "-10px",
          left: "calc(50% - 10px)",
        };
      case "bottom":
        return {
          ...baseStyles,
          borderWidth: "0 10px 10px 10px",
          borderColor: "transparent transparent #333 transparent",
          top: "-10px",
          left: "calc(50% - 10px)",
        };
      case "left":
        return {
          ...baseStyles,
          borderColor: "transparent transparent transparent #333",
          borderWidth: "10px 0 10px 10px",
          right: "-10px",
          top: "calc(50% - 10px)",
        };
      case "right":
        return {
          ...baseStyles,
          borderWidth: "10px 10px 10px 0",
          borderColor: "transparent #333 transparent transparent",
          left: "-10px",
          top: "calc(50% - 10px)",
        };
      default:
        return baseStyles;
    }
  }

  const toggleTooltip = (e, state = true) => {
    if (e.type === "click") {
      toggledByClick.current = !toggledByClick.current;
      setTooltipShow(toggledByClick.current);
    } else if (!toggledByClick.current) {
      setTooltipShow(state);
    }
  };

  return (
    <>
      <button
        ref={btnRef}
        className={className}
        onMouseOver={toggleTooltip}
        onMouseOut={(e) => toggleTooltip(e, false)}
        onTouchStart={toggleTooltip}
        onTouchEnd={(e) => toggleTooltip(e, false)}
        onClick={toggleTooltip}
        aria-label="Toggle tooltip"
      >
        {children}
      </button>
      {tooltipShow && (
        <div
          ref={tooltipRef}
          style={{
            zIndex: 1000,
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px",
            borderRadius: "3px",
          }}
        >
          {tooltipText}
          <div ref={arrowRef} style={getArrowStyles(placement)}></div>
        </div>
      )}
    </>
  );
};

export default Tooltip;
